// extracted by mini-css-extract-plugin
module.exports = {"modal":"NewVersionModal_modal__H0iFP","form":"NewVersionModal_form__IrBUo","field":"NewVersionModal_field__3Nx8R"};